import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum ScheduleDemoButtonLocation {
  PERSONALIZED_SHIPPING = "PERSONALIZED_SHIPPING",
  DYNAMIC_SHIPPING = "DYNAMIC_SHIPPING",
  SHIPPING_AI = "SHIPPING_AI",
  SEGMENTATION = "SEGMENTATION",
  CHECKOUT_UPSELL = "CHECKOUT_UPSELL",
  POST_PURCHASE_UPSELL = "POST_PURCHASE_UPSELL",
  CHECKOUT_PROBABILITY = "CHECKOUT_PROBABILITY",
  CHECKOUT_INSIGHTS = "CHECKOUT_INSIGHTS",
  // Intent-only locked-feature surfaces (CRO-1387). Each NAV_* value tracks a
  // sidebar nav-item click; INTENT_SIDEBAR_PROMO tracks the bottom-of-sidebar
  // upsell card.
  NAV_AB_TESTS = "NAV_AB_TESTS",
  NAV_ANALYTICS = "NAV_ANALYTICS",
  NAV_CHECKOUTS = "NAV_CHECKOUTS",
  NAV_DISCOUNT_RULES = "NAV_DISCOUNT_RULES",
  NAV_POST_PURCHASE_UPSELL = "NAV_POST_PURCHASE_UPSELL",
  NAV_PRICING_TESTS = "NAV_PRICING_TESTS",
  NAV_WIDGETS = "NAV_WIDGETS",
  INTENT_SIDEBAR_PROMO = "INTENT_SIDEBAR_PROMO",
  AB_TESTS_ONBOARDING_BANNER = "AB_TESTS_ONBOARDING_BANNER",
}

const CHOP_XSELL_SCHEDULE_DEMO_DESTINATION_URL =
  "https://meetings.hubspot.com/spencer-jorgensen/chop-xsell?uuid=197f01e8-9a8a-4dfb-99b8-14138379fcb8";

export function getScheduleDemoDestinationUrl() {
  return CHOP_XSELL_SCHEDULE_DEMO_DESTINATION_URL;
}

export const sendScheduleDemoClickedNotification = {
  name: "sendScheduleDemoClickedNotification" as const,
  input: z.object({
    source: createEnum(ScheduleDemoButtonLocation),
    calendarUrl: z.string(),
  }),
  output: z.null(),
};
